import React from "react";
import Field from "@gqlapp/forms-client-react/FieldAdapter";
import RenderField from "@gqlapp/base/RenderRadiosBox";

export default (function Radio(props){

	let options = props?.options || [];
	let setFieldValue = props?.setFieldValue || {}
	let values = props?.values || {}
	let required = !props?.required || '';
	let name = props?.id;

	let value = values[name];

	options = options.map(({ title: label, weight: value })=>({ label, value }))

	return <>
		<Field
			sx={{ width: '100%', '& .MuiFormControlLabel-root':{ margin: 0 }}}
			{...{ onChange: (name, value) => setFieldValue(name, value)}}
			{...{ className: 'Mui-textfield', label: props?.name, component: RenderField }}
			{...{ value, name, options, required }}
		/>
	</>
})